export default "__VITE_ASSET__R$3LmqDU__"